export class ParamGroup {
  id: number;
  name: string;
  description: string;
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/paramGroup.model.ts